(() => {
  if (window.__rebAccessoryInitialized) return;
  window.__rebAccessoryInitialized = true;

  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  }).format(Number(cents) / 100);

  function initGallery(gallery) {
    if (gallery.dataset.rebReady) return;
    gallery.dataset.rebReady = 'true';
    const viewport = gallery.querySelector('[data-reb-gallery-viewport]');
    const slides = [...gallery.querySelectorAll('[data-reb-media-index]')];
    const thumbs = [...gallery.querySelectorAll('[data-reb-media-target]')];
    const counter = gallery.querySelector('[data-reb-gallery-counter]');
    const previous = gallery.querySelector('[data-reb-gallery-prev]');
    const next = gallery.querySelector('[data-reb-gallery-next]');
    let current = 0;
    function select(index, scroll = true) {
      current = Math.max(0, Math.min(index, slides.length - 1));
      if (scroll) viewport?.scrollTo({ left: current * viewport.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      thumbs.forEach((button) => button.setAttribute('aria-current', String(Number(button.dataset.rebMediaTarget) === current)));
      if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
      if (previous) previous.disabled = current === 0;
      if (next) next.disabled = current === slides.length - 1;
    }
    thumbs.forEach((button) => button.addEventListener('click', () => select(Number(button.dataset.rebMediaTarget))));
    previous?.addEventListener('click', () => select(current - 1));
    next?.addEventListener('click', () => select(current + 1));
    let frame;
    viewport?.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => select(Math.round(viewport.scrollLeft / viewport.clientWidth), false));
    }, { passive: true });
  }

  async function addToCart(id, button, error, form) {
    button.disabled = true;
    if (error) error.hidden = true;
    let added = false;
    try {
      const drawer = document.querySelector('cart-drawer');
      const data = form ? new FormData(form) : new FormData();
      data.set('id', String(id));
      data.set('quantity', '1');
      if (drawer?.renderContents) {
        data.set('sections', 'cart-drawer,cart-icon-bubble');
        data.set('sections_url', location.pathname);
      }
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Could not add to cart');
      added = true;
      if (drawer?.renderContents) {
        if (!result.sections?.['cart-drawer']) {
          const url = new URL(window.routes?.cart_url || '/cart', location.origin);
          url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
          const sectionsResponse = await fetch(url);
          if (!sectionsResponse.ok) throw new Error('Could not refresh cart');
          result.sections = await sectionsResponse.json();
        }
        if (!result.sections?.['cart-drawer']) throw new Error('Could not refresh cart');
        drawer.renderContents(result);
      } else {
        const cart = await fetch(window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js').then((res) => res.json());
        document.querySelectorAll('.reb-cart-count').forEach((count) => { count.textContent = String(cart.item_count); });
        if (error) { error.textContent = 'Added to cart'; error.hidden = false; }
      }
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'reb-accessory', cartData: result, variantId: id });
      }
    } catch (failure) {
      if (added) { location.reload(); return; }
      if (error) { error.textContent = failure.message || 'Could not add to cart'; error.hidden = false; }
      button.disabled = false;
    } finally {
      if (added) button.disabled = false;
    }
  }

  function initProduct(section) {
    if (section.dataset.rebReady) return;
    section.dataset.rebReady = 'true';
    section.querySelectorAll('[data-reb-acc-gallery]').forEach(initGallery);
    const form = section.querySelector('[data-reb-acc-form]');
    const variantInput = form?.querySelector('[data-reb-variant-id]');
    const add = form?.querySelector('[data-reb-add-button]');
    const notify = section.querySelector('[data-reb-notify]');
    const tags = notify?.querySelector('[data-reb-notify-tags]');
    const price = section.querySelector('[data-reb-price]');
    const error = form?.querySelector('.reb-acc-error');
    const productHandle = location.pathname.split('/products/')[1]?.split('/')[0] || '';
    function setVariant(variant) {
      if (!variant) { add.disabled = true; notify.hidden = true; return; }
      variantInput.value = variant.id;
      add.disabled = !variant.available;
      notify.hidden = Boolean(variant.available);
      if (tags) tags.value = `notify, ${productHandle}, ${variant.title}`;
      if (price) price.textContent = variant.formattedPrice || money(variant.price);
    }
    if (section.hasAttribute('data-reb-swag-product')) {
      let variants = [];
      try { variants = JSON.parse(section.querySelector('[data-reb-variants]')?.textContent || '[]'); } catch { /* Keep the first selected variant. */ }
      const groups = [...section.querySelectorAll('[data-reb-option]')];
      const selected = groups.map((group) => group.querySelector('[aria-pressed=true]')?.dataset.rebOptionValue);
      function choose(groupIndex, value) {
        selected[groupIndex] = value;
        let variant = variants.find((candidate) => candidate.options.every((optionValue, index) => optionValue === selected[index]));
        if (!variant) {
          variant = variants.find((candidate) => candidate.options[groupIndex] === value);
          if (variant) variant.options.forEach((optionValue, index) => { selected[index] = optionValue; });
        }
        groups.forEach((group, index) => {
          group.querySelectorAll('[data-reb-option-value]').forEach((button) => {
            const candidateValue = button.dataset.rebOptionValue;
            button.setAttribute('aria-pressed', String(selected[index] === candidateValue));
            const available = variants.some((candidate) => candidate.available && candidate.options[index] === candidateValue && candidate.options.every((other, otherIndex) => otherIndex === index || other === selected[otherIndex]));
            button.classList.toggle('is-sold-out', !available);
            const soldOut = button.querySelector('.reb-acc-sold-out');
            if (soldOut) soldOut.hidden = available;
            else if (!available) { const label = document.createElement('span'); label.className = 'reb-acc-sold-out'; label.textContent = 'Sold out'; button.append(label); }
          });
        });
        setVariant(variant);
      }
      groups.forEach((group, index) => group.querySelectorAll('[data-reb-option-value]').forEach((button) => button.addEventListener('click', () => choose(index, button.dataset.rebOptionValue))));
      if (groups.length) choose(0, selected[0]);
    } else {
      section.querySelectorAll('[data-reb-variant-choice]').forEach((button) => button.addEventListener('click', () => {
        section.querySelectorAll('[data-reb-variant-choice]').forEach((choice) => choice.setAttribute('aria-pressed', String(choice === button)));
        setVariant({ id: button.dataset.id, available: button.dataset.available === 'true', price: null, formattedPrice: button.dataset.price, title: button.dataset.title });
      }));
    }
    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!add.disabled) addToCart(variantInput.value, add, error, form);
    });
  }

  function reviewCard(source) {
    const score = Number(source.querySelector('.jdgm-rev__rating[data-score]')?.dataset.score);
    const author = source.querySelector('.jdgm-rev__author')?.textContent.trim();
    const timestamp = source.querySelector('.jdgm-rev__timestamp')?.getAttribute('datetime');
    const title = source.querySelector('.jdgm-rev__title')?.textContent.trim();
    const body = source.querySelector('.jdgm-rev__body')?.textContent.trim();
    if (!Number.isInteger(score) || score < 0 || score > 5 || !author || !body) return null;
    const card = document.createElement('article');
    card.className = 'reb-pdp-reviews__card';
    const stars = document.createElement('span');
    stars.className = 'reb-pdp-reviews__stars';
    stars.setAttribute('aria-label', `${score} out of 5 stars`);
    stars.textContent = '★'.repeat(score) + '☆'.repeat(5 - score);
    card.append(stars);
    if (source.dataset.verifiedBuyer === 'true') {
      const badge = document.createElement('span'); badge.className = 'reb-reviews__verified'; badge.textContent = 'VERIFIED'; card.append(badge);
    }
    const byline = document.createElement('p'); byline.className = 'reb-pdp-reviews__byline';
    const name = document.createElement('strong'); name.textContent = author; byline.append(name);
    if (timestamp && !Number.isNaN(Date.parse(timestamp))) {
      const time = document.createElement('time'); time.dateTime = timestamp;
      time.textContent = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(timestamp));
      byline.append(time);
    }
    card.append(byline);
    if (title) { const heading = document.createElement('h3'); heading.textContent = title; card.append(heading); }
    const copy = document.createElement('p'); copy.className = 'reb-pdp-reviews__body'; copy.textContent = body; card.append(copy);
    return card;
  }

  function initReviews(section) {
    if (section.dataset.rebReady) return;
    section.dataset.rebReady = 'true';
    const list = section.querySelector('[data-reb-reviews-list]');
    const more = section.querySelector('[data-reb-reviews-more]');
    const status = section.querySelector('[data-reb-reviews-status]');
    const empty = section.querySelector('[data-reb-reviews-empty]');
    let page = 1;
    let loaded = 0;
    async function load() {
      more.disabled = true;
      const url = new URL('https://judge.me/reviews/reviews_for_widget');
      url.search = new URLSearchParams({ url: section.dataset.shopDomain, shop_domain: section.dataset.shopDomain, platform: 'shopify', page: String(page), per_page: '10', product_id: section.dataset.productId });
      try {
        const response = await fetch(url, { credentials: 'omit' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        if (typeof data.html !== 'string' || !Number.isFinite(Number(data.total_count))) throw new Error('Invalid review feed');
        const total = Number(data.total_count);
        status.hidden = true;
        if (total === 0) { empty.hidden = false; return; }
        const source = new DOMParser().parseFromString(data.html, 'text/html');
        const cards = [...source.querySelectorAll('.jdgm-rev')].map(reviewCard).filter(Boolean);
        if (!cards.length && loaded < total) throw new Error('No readable reviews');
        list.append(...cards);
        loaded += cards.length;
        more.hidden = loaded >= total || cards.length < 10;
        more.disabled = false;
        page += 1;
      } catch (failure) {
        status.textContent = 'Reviews are temporarily unavailable';
        status.hidden = false;
        more.hidden = true;
      }
    }
    more.addEventListener('click', load);
    load();
  }

  function init() {
    document.querySelectorAll('[data-reb-acc-product]').forEach(initProduct);
    document.querySelectorAll('[data-reb-acc-reviews]').forEach(initReviews);
    document.querySelectorAll('[data-reb-acc-add]').forEach((button) => {
      if (button.dataset.rebReady) return;
      button.dataset.rebReady = 'true';
      button.addEventListener('click', () => addToCart(button.dataset.variantId, button, button.parentElement.querySelector('.reb-acc-error')));
    });
    const guide = document.querySelector('[data-reb-size-guide]');
    const slot = document.querySelector('[data-reb-size-guide-slot]');
    if (guide && slot && guide.parentElement !== slot) slot.append(guide);
    else if (guide && !slot) guide.hidden = true;
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
